import gql from 'graphql-tag'

export const GET_ALL_EVENT_PASSWORDS = gql`
  query GetAllEventPasswords($eventId: ID!) {
    getAllPasswordsByEventId(eventId: $eventId) {
      id
      password
    }
  }
`

export const CREATE_EVENT_PASSWORD = gql`
  mutation CreateEventPassword($eventId: ID!, $password: String!) {
    createEventPassword(eventId: $eventId, password: $password)
  }
`

export const UPDATE_EVENT_PASSWORD = gql`
  mutation UpdateEventPassword($eventId: ID!,$id: ID!, $password: String!) {
    updateEventPassword(eventId: $eventId, id: $id, password: $password)
  }
`

export const DELETE_EVENT_PASSWORD = gql`
  mutation DeleteEventPassword($eventId: ID!,$id: ID!) {
    deleteEventPassword(eventId: $eventId, id: $id)
  }
`

export const VERIFY_EVENT_PASSWORD = gql`
query VerifyEventPassword($eventId: ID!, $password: String!) {
  verifyEventPassword(eventId: $eventId, password: $password)
}
`
